import { useEffect, useState } from "react"
import Select from 'react-select'
import { IContrapartesWs, IPalabrasAgrovocWs } from "../../../interfaces/Workspace"
import { getContrapartesWs } from "../../../api/contrapartesWs"
import { getPalabrasClaveWs } from "../../../api/palabrasAgrovocWs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import { Input } from "../../../util/inputs"
import { getPalabrasIniciativas, getPalabrasIniciativasRegionales } from "../../../api/palabrasLogros"

const Filtros: React.FC<{
    pageType: "contrapartes" | "palabras" | "en-numeros" | "regionales",
    colClass?: string,
    paisId?: string
    filter: (contraparte?: number, palabraClave?: number, busquedaTextual?: string, isArchivo?: number) => void
}> = ({ pageType, filter, colClass = "col-12", paisId = undefined }) => {

    const { t, i18n } = useTranslation()

    const [listaContrapartes, setListaContrapartes] = useState<IContrapartesWs[]>()
    const [listaPalabrasClave, setListaPalabrasClave] = useState<IPalabrasAgrovocWs[]>()

    const [contraparte, setContraparte] = useState<IContrapartesWs>()
    const [palabraClave, setPalabraClave] = useState<IPalabrasAgrovocWs>()
    const [busquedaTextual, setBusquedaTextual] = useState<string>()
    const [isArchivo, setIsArchivo] = useState<{ value: number, label: string }>({ value: 0, label: t("iniciativas.actualidad")! })

    useEffect(() => {
        switch (pageType) {
            case "contrapartes":
                getContrapartesWs()
                    .then((res) => {
                        setListaPalabrasClave(undefined)
                        setListaContrapartes(res)
                    })
                break;
            case "en-numeros": //IICA en números
                getPalabrasIniciativas({idioma:i18n.language, paisId:paisId})
                .then((res) => {
                    setListaContrapartes(undefined)
                    setListaPalabrasClave(res)
                })
                break
            case "regionales": //IICA en números
                getPalabrasIniciativasRegionales({idioma:i18n.language, paisId:paisId})
                .then((res) => {
                    setListaContrapartes(undefined)
                    setListaPalabrasClave(res)
                })
                break
            default: //Palabras clave
                getPalabrasClaveWs(i18n.language)
                .then((res) => {
                    setListaContrapartes(undefined)
                    setListaPalabrasClave(res)
                })          
                break;
        }
        return () => {
            setContraparte(undefined)
            setPalabraClave(undefined)
            setBusquedaTextual(undefined)
            setIsArchivo({ value: 0, label: t("iniciativas.actualidad")! })
            console.log("cleaned up");
        };
    }, [pageType, i18n.language])

    return (
        <>
            <h5 className="mt-2 mb-3 text-muted">
                {
                    pageType === "contrapartes" ?
                        t("intro.alianzas") :
                        pageType === "palabras" ?
                            t("intro.resultados") : null
                }
            </h5>
            <div className="row">
                <Input className="col-sm-12 col-md-6 col-lg-3"
                    label="Búsqueda textual"
                    id="busqueda_textual"
                    value={busquedaTextual}
                    onChange={(e) => { setBusquedaTextual(e.target.value) }} />
                {
                    listaContrapartes ?
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Select isClearable value={contraparte} onChange={(newValue) => { setContraparte(newValue!) }} options={listaContrapartes} placeholder={t("generic.buscar_pais")}
                                getOptionValue={(option) => `${option['id_ContraFinanciera']}`}
                                getOptionLabel={(option) => `${option.descripcion}`}
                            />
                        </div> : null
                }
                {
                    listaPalabrasClave ?
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Select isClearable value={palabraClave} onChange={(newValue) => { setPalabraClave(newValue!) }} options={listaPalabrasClave} placeholder={t("generic.buscar_clave")}
                                getOptionValue={(option) => `${option['fK_Id_CodigoAgrovoc']}`}
                                getOptionLabel={(option) => `${option.termino}`} />
                        </div> : null
                }
                {
                    pageType !== "en-numeros" && pageType !== "regionales" ?
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Select value={isArchivo} onChange={(newValue) => { setIsArchivo(newValue!) }} options={[
                                { value: 0, label: t("iniciativas.actualidad")! },
                                { value: 1, label: t("iniciativas.historico")! },
                            ]} />
                        </div> : null
                }
                <div className="col-sm-12 col-md-6 col-lg-2">
                    <button type="button" onClick={() => { filter(contraparte?.id_ContraFinanciera, palabraClave?.fK_Id_CodigoAgrovoc, busquedaTextual, isArchivo.value) }} className="btn btn-success me-1"><FontAwesomeIcon icon={faSearch} /> {t("generic.buscar")}</button>
                </div>
            </div>
        </>
    )
}

export default Filtros